import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import React, {useState} from 'react'
import {useAppDispatch} from '../../../app/hooks'
import {useNavigate} from 'react-router-dom'
import {deleteUserAccount} from '@meprism/shared/src/redux/authentication/authenticationSlice'
import AnalyticsManager from '../../../services/AnalyticsManager'
import WarningIcon  from '@meprism/shared/src/assets/icons/warningicon.svg';

const styles = {
  heading:{
    color: '#3A155A',
    fontFamily: 'InterMedium',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '27px',
    textTransform: 'uppercase',
  },
  bulletIcon: {
    fontSize: '8px',
    color: 'black',
  },
  delAcc: {
    width: {xs: '100%', sm: '181px'},
    maxWidth: {xs:'152px', md: '300px'},
    height: 50,
    borderRadius: '10px',
    fontSize: {xs: '14px'}, 
    fontFamily: 'InterMedium',
    fontWeight: 500,
    background: '#9135E0',
    color: '#fff',
    '&.Mui-disabled': {
      background: '#9135E0',
      color: '#fff',
    },
    ':hover': {
      background: '#9135E0',
      color: '#fff',
    },
  },
  dialogPaper: {
    borderRadius: '16px',
    padding: '32px',
  },
  listIconWidth: {
    minWidth: '35px',
  },
  listItem: {
    py: 0,
  },
  dialogTitle: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: 'center',
    fontFamily: 'InterBold',
    color: 'rgb(26, 27, 32)',
    p: 0,
  },
  dialogContent: {
    p: 0,
  },
  listText: {
    fontFamily: 'InterRegular',
    color: '#615F6B',
    fontSize: { xs: 12, md: 15, lg: 16 },
    lineHeight: { xs: 1.2, md: 1.2, lg: 1.5 },
    p: 0,
  },
  button:{
    width: { xs: '45%', md: '35%', lg: '30%' },
    borderRadius: '10px',
    fontSize: { xs: 10, md: 14 },
    boxShadow: 'unset',
    border: '1px solid #9135E0', 
  }
}

const DeleteAcc = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [isOpenDialog, setOpenDialog] = useState(false)
  
  const handleDeleteAcc = async () => {
    await dispatch(deleteUserAccount())
    await AnalyticsManager.trackTypedEvent(
      {
        event: "Account Deleted - Web",
        source: 'Web App'
      }
    )
    navigate('/login')
  }

  const closeDeleteAccDialog = () => {
    setOpenDialog(false)
  }

  return (
    <Grid item xs={12}>
      <Grid container columnSpacing={2.5} rowSpacing={3.5}>
      <Grid item md={12} xs={12}>
        <Typography sx={styles.heading}>Delete Account</Typography>
      </Grid>

      <Grid item xs={12}>
        <Button sx={styles.delAcc} onClick={() => setOpenDialog(true)}>
          Delete Account
        </Button>
      </Grid>
      <Dialog
        open={isOpenDialog}
        onClose={closeDeleteAccDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            ...styles.dialogPaper,
            width: {xs: '80%', sm: '50%', lg: '40%'},
            maxWidth: '680px'
          },
        }}
        >
        <DialogTitle sx={styles.dialogTitle}>
          <img src={WarningIcon} style={{  width: '8vw', maxWidth: '100px', minWidth: '60px', height: 'auto', }} />
          <Typography 
            sx={{fontSize: { xs: 18, md: 22, lg: 24 },
                fontWeight: 600,
                lineHeight: { xs: 1, md: 1.2, lg: 1.5 }}}
                >
                Are you sure you want to delete your account?
          </Typography>
        </DialogTitle>
        <DialogContent  sx={styles.dialogContent}>
          <DialogContentText>
            <Grid item md={12}>
              <List>
                {[
                  'This will permanently delete your PrivacyCloak account and you will lose all your opt out progress & profile info.',
                  'We will no longer be supporting you to remove your personal information from the internet.',
                  'The authorization agreement will be deemed terminated.',
                  'This action can not be undone.',
                ].map((text, i) => (
                  <ListItem key={i} sx={styles.listItem}>
                    <ListItemIcon sx={styles.listIconWidth}>
                      <CircleIcon sx={styles.bulletIcon} />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{ sx: styles.listText }}
                      primary={text}
                    />
                  </ListItem>
                ))}
              </List>

            </Grid>
          </DialogContentText>
          <DialogActions 
            sx={{
              ...styles.dialogContent,
              justifyContent: 'center',
              gap: {xs: 1, md: 4, lg: 6}, 
            }}
            >
            <Button
              onClick={closeDeleteAccDialog}
              sx={{
                ...styles.button,
                background: 'transparent',
                color: '#9135E0',
                ':hover': { background: 'transparent' },
              }}
              >
              Cancel
            </Button>
            <Button
             onClick={handleDeleteAcc}
             sx={{
                ...styles.button,
                background: '#9135E0',
                color: '#fff',
                ':hover': { background: '#9135E0' },
             }}
             >
              Delete Account
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      </Grid>
    </Grid>
  )
}

export default DeleteAcc
